// Usage: v-popover:placement[.trigger1][.trigger2] ="Text to display"
class VuePopover {
  constructor() {
    this.availableTriggers = ['click', 'hover', 'focus', 'manual'];
  }

  create(el, binding, { props }) {
    const title = props.title ?? '';
    const placement = props['data-placement'] ?? 'right';
    const html = props['data-html'] ?? false;
    const trigger = this.getTrigger(binding, { props });

    el.setAttribute('role', 'button');
    const $el = $(el);

    $el.popover({
      title,
      content: binding.value,
      placement: binding.arg ?? placement,
      trigger,
      html,
    });
  }

  getTrigger(binding, { props }) {
    if (this.hasTriggerModifiers(binding)) {
      return this.buildTrigger(binding);
    }

    return props['data-trigger'] ?? 'click';
  }

  hasTriggerModifiers(binding) {
    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        return true;
      }
    }

    return false;
  }

  buildTrigger(binding) {
    const t = [];

    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        t.push(trigger);
      }
    }

    return t.join(' ');
  }

  static destroy(el) {
    $(el).popover('dispose');
  }
}

const popover = new VuePopover();

export const create = (el, binding, vNode) => {
  if (!Object.prototype.hasOwnProperty.call(binding, 'value') || !binding.value) {
    return;
  }

  popover.create(el, binding, vNode);
};
export const beforeUnmount = el => VuePopover.destroy(el);
